import { Group, Stack } from '@mantine/core';
import { AvatarSkeleton, TextSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { AiChatEmbedPreviewBody } from './AiChatEmbedPreviewBody';

export const AiChatEmbedPreviewSkeleton = memo(() => (
	<AiChatEmbedPreviewBody>
		<Group spacing="sm" noWrap>
			<AvatarSkeleton size="md" />
			<Stack spacing="xs" w="100%">
				<TextSkeleton size="xs" width="30%" />
				<TextSkeleton size="xs" width="50%" />
			</Stack>
		</Group>
	</AiChatEmbedPreviewBody>
));
